import Container from "../../components/Container";
import Footer from "../../components/Footer";
import ListHeader from "../../components/ListHeader";
import Navbar from "../../components/Navbar";
import React from "react";
import SponsorsImage from "../../statics/img/sponsors.png";
import SubscriptionSection from "../../components/SubscriptionSection";

const Expo = () => {
  return (
    <div className="ExpoPage">
      <Navbar />

      <Container>
        <div className="mt-8">
          <ListHeader title="EXPO" header="Our Sponsors" />

          <div className="my-8">
            <img src={SponsorsImage} alt="Our Sponsors" />
          </div>
        </div>
      </Container>

      <SubscriptionSection />
      <Footer />
    </div>
  );
};

export default Expo;
